<template>
	<q-layout-header>
		<q-toolbar class="mobile-hide no-shadow">
			<div class="col-12 flex justify-end">
				<global-search />

				<client />

				<country />

				<div>
					<q-btn
						flat
						:label="$t('control_panel')"
						icon="fas fa-tachometer-alt"
						@click="$router.push({ name: 'admin_overview' })"
						v-if="showControlPanel"
					/>
				</div>

				<notification />

				<user-menu />

				<language />
			</div>
		</q-toolbar>

		<q-toolbar class="desktop-hide">
			<q-btn flat round dense @click="openMenu()" icon="fas fa-bars" />

			<q-toolbar-title>
				{{ $t(getTitle) }} <span v-if="is_offline"> - Offline</span>
			</q-toolbar-title>

			<notification />
		</q-toolbar>

		<change-password
			:show_change_password="show_change_password"
			@hide_modal="show_change_password = false"
		/>

		<welcome-banner />

		<mandatory-survey />
	</q-layout-header>
</template>

<script>
import { colors } from 'quasar'
import { mapGetters } from 'vuex'
import Notification from 'components/header/Notification'
import ChangePassword from 'components/ChangePassword'
import WelcomeBanner from 'components/authenticated/WelcomeBanner.vue'
import MandatorySurvey from 'components/authenticated/MandatorySurvey.vue'
import Client from 'components/header/Client'
import Country from 'components/header/Country'
import UserMenu from 'components/header/UserMenu'
import Language from 'components/header/Language'
import GlobalSearch from 'components/header/GlobalSearch'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'authenticated'] },
	components: {
		notification: Notification,
		'change-password': ChangePassword,
		'welcome-banner': WelcomeBanner,
		'mandatory-survey': MandatorySurvey,
		client: Client,
		country: Country,
		'user-menu': UserMenu,
		language: Language,
		'global-search': GlobalSearch,
	},

	data() {
		return {
			links: [
				{
					icon: 'fas fa-home',
					to: 'home',
					text: 'home',
				},
				{
					icon: 'fas fa-book-reader',
					to: 'courses',
					text: 'courses',
				},
				{
					icon: 'fas fa-bezier-curve',
					to: 'trails',
					text: 'trails',
				},
				{
					icon: 'fas fa-book',
					to: 'library',
					text: 'library',
				},
				{
					icon: 'far fa-calendar-alt',
					to: 'calendar',
					text: 'calendar',
				},
				{
					icon: 'far fa-user',
					to: 'profile',
					text: 'my_profile',
				},
				{
					icon: 'far fa-question-circle',
					to: 'help',
					text: 'help',
				},
			],
			show_change_password: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			full_name: 'common/full_name',
			user_clients: 'common/user_clients',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			user_module_items: 'common/user_module_items',
			id_user_language_selected: 'common/id_user_language_selected',
			reload_content: 'common/reload_content',
			is_offline: 'offline/is_offline',
			clients: 'params/clients',
			app_version: 'params/login_app_version',
			languages: 'params/languages',
			id_user_language_selected: 'common/id_user_language_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			user_change_password: 'common/user_change_password',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getTitle() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) {
				switch (this.$route.meta.title) {
					case 'home':
						return obj.title_home == '' ? 'home' : obj.title_home
						break
					case 'courses':
						return obj.title_trainings == '' ? 'courses' : obj.title_trainings
						break
					case 'trails':
						return obj.title_trails == '' ? 'trails' : obj.title_trails
						break
					case 'webcasts':
						return obj.title_webcasts == '' ? 'webcasts' : obj.title_webcasts
						break
					case 'library':
						return obj.title_library == '' ? 'library' : obj.title_library
						break
					case 'news':
						return obj.title_news == '' ? 'news' : obj.title_news
						break
					case 'feed':
						return obj.title_feed == '' ? 'feed' : obj.title_feed
						break
					case 'faq':
						return obj.title_faq == '' ? 'faq' : obj.title_faq
						break
					case 'profile':
						return obj.title_profile == '' ? 'profile' : obj.title_profile
						break
					default:
						return this.$route.meta.title
						break
				}
			}

			return this.$route.meta.title
		},

		showControlPanel() {
			if (this.user_module_items) {
				// let objects = ['overview', 'tags', 'trainings', 'trails', 'general_tests', 'library_categories', 'library', 'users', 'users_groups', 'users_import', 'headquarter', 'branch', 'news', 'banners', 'surveys', 'faq', 'configuration', 'terms', 'about', 'policy']
				let allow = false
				let obj = this.user_module_items.find((obj) => {
					return obj.permission == true
				})
				if (obj) allow = true
				return allow
			} else return false
		},
	},

	methods: {
		openMenu() {
			this.$store.dispatch('common/SET_LEFT_MENU', [true])
		},
	},

	created() {
		if (this.user_change_password) this.show_change_password = true
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
